<template lang='pug'>
  .container
    article
      h2 Allgemeines Zivilrecht
</template>

<script>
export default {
  name: 'Zivilrecht',
  data () {
    return {}
  }
}
</script>

<style lang='stylus' scoped>
</style>


// WEBPACK FOOTER //
// src/components/content/Zivilrecht.vue